export default [
    {
        title: "mainmenu.apps",
        route: "apps",
        icon: "grid-2",
        class: "d-none d-sm-block",
        resource: "apps",
        action: "update",
    },
];
